
<div class="gallery-container">
    <div id="viewerSection" class="molstar-frozen">
        <!-- Molstar container -->
        <div id="myViewerCover"></div>
        <button (click)="previous()" class="arrow-left left"><img src="/assets/img/mobile/left-mat-btn.svg" alt="arrow-left"/></button>
        <div id="myViewer"></div>
        <button (click)="next()" class="arrow-right right"><img src="/assets/img/mobile/right-mat-btn.svg" alt="arrow-left"/></button>
    </div>
    
    <div class="gallery-nav">
        <div class="dot-indicators">
          <span 
            *ngFor="let view of views; let i = index" 
            [class.active]="i === currentIndex"
            (click)="setView(i)"
          ></span>
        </div>
    </div>
      
</div>
